import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/homepage/Footer";

export const Route = createFileRoute('/legal')({
  component: LegalLayout,
});

function LegalLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container px-6 py-16">
        <div className="mx-auto max-w-4xl prose prose-gray dark:prose-invert">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}
